import React, {Component} from "react";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {DefaultBtn, SearchInput} from "Ncontracts.Common.UI";
import isEmpty from "../../helpers/isEmpty";
import {SET_SELECTED_EVENT_ID} from "../../actions/communications/communicationsAction";

class AssociateEventModal extends Component {

    static propTypes = {
        discardButtonHandler: PropTypes.func,
        events: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
            title: PropTypes.string,
            type: PropTypes.string
        })),
        isActive: PropTypes.bool,
        saveButtonHandler: PropTypes.func,
        selectedEventId: PropTypes.number,
        setSelectedEventId: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            filteredEvents: this.props.events.slice(),
            searchValue: ''
        };
    }

    handleSearchValueChange = newValue => {
        this.setState({...this.state, searchValue: newValue}, () => {
            this.updateFilteredEvents();
        });
    };

    updateFilteredEvents = () => {
        const {searchValue} = this.state;

        const filteredList = isEmpty(searchValue) ? this.props.events :
            this.props.events.filter(e =>
                e.title.toLowerCase().includes(searchValue.toLowerCase()) ||
                (!isEmpty(e.type) && e.type.toLowerCase().includes(searchValue.toLowerCase()))
            );

        this.setState({...this.state, filteredEvents: filteredList});
    };

    getEventListItems = () => {
        const {filteredEvents} = this.state;

        const listItems = filteredEvents.map(e => {
            const isSelected = e.id === this.props.selectedEventId;
            return (
                <div className={`list-row ${isSelected ? 'selected' : ''}`} key={e.id}
                     onClick={() => this.props.setSelectedEventId(e.id)}>
                    {e.title} (Type: {e.type})
                </div>
            );
        });

        return listItems;
    };

    render() {
        return (
            <div className={`modal associate-event-modal ${this.props.isActive ? 'is-active' : ''}`}>
                <div className="modal-background"/>
                <div className="modal-card modal-content">
                    <header className="modal-card-head">
                        <div className="modal-card-title">Associate Event</div>
                    </header>
                    <section className="modal-card-body">
                        <div className="associate-event-form">
                            <div className="search-container">
                                <SearchInput
                                    alwaysOpen
                                    tooltipText="Search"
                                    onValueChange={this.handleSearchValueChange}
                                    placeholder="Search" delay={500}/>
                            </div>
                            <div className="event-list">
                                {this.getEventListItems()}
                            </div>
                        </div>
                    </section>
                    <footer className="modal-card-foot">
                        <div className="modal-footer-buttons">
                            <DefaultBtn onClick={this.props.discardButtonHandler}
                                        className="btn--base btn--smaller">Discard</DefaultBtn>
                            <DefaultBtn onClick={this.props.saveButtonHandler}
                                        className="btn--solid btn--smaller">Save</DefaultBtn>
                        </div>
                    </footer>
                </div>
            </div>);
    }
}

const mapStateToProps = state => ({
    selectedEventId: state.communications.selectedCommunication.selectedEventId,
});

const mapDispatchToProps = dispatch => ({
    setSelectedEventId: id => dispatch({type: SET_SELECTED_EVENT_ID, eventId: id}),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssociateEventModal));
